export default "__VITE_ASSET__pYIQYKRm__"